import * as React from "react"
import Layout from "../../components/Layout"
import Seo from "../../components/SEO"
import SimpleBanner from "../../components/SimpleBanner/SimpleBanner"
import { StaticImage } from "gatsby-plugin-image"
import ProductCategory from "../../components/ProductCategory/ProductCategory"
import PageLinks from "../../components/PageLinks/PageLinks"

const speedmachine = () => {
  return (
    <>
      <Seo title="고속가공기" />
      <Layout>
        <SimpleBanner subtitle="절삭가공" title="고속가공기">
          <StaticImage
            className="banner__image"
            src="../../images/feeler/lathesCover.png"
            layout="constrained"
            placeholder="blurred"
          />
        </SimpleBanner>
        <ProductCategory productCategory="speedmachine" />
        <PageLinks brand="feeler" />
      </Layout>
    </>
  )
}

export default speedmachine
